"use client"

import { useState } from "react"

export function useCategorisedRouteFlag() {
  const [useCategoriesFlag, setUseCategoriesFlag] = useState(true);

  return {
    useCategoriesFlag,
    setUseCategoriesFlag
  }
}